export default {
	"components.UnbindAccount": "解綁賬號"
}